import { graphql } from '@/gql';
import type { HomeServiceProvidersQueryVariables } from '@/gql/graphql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const fetchHomeServiceProviders = async ({
  searchType,
  searchValue,
  serviceType,
  city,
  state,
  isActive,
  pagination,
}: HomeServiceProvidersQueryVariables) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      searchType,
      searchValue,
      serviceType,
      city,
      state,
      isActive,
      pagination,
    },
    query: graphql(`
      query HomeServiceProviders(
        $searchType: HomeServiceProviderSearchType
        $searchValue: String
        $serviceType: HomeServiceType
        $city: String
        $state: String
        $isActive: Boolean
        $pagination: PaginationInputType
      ) {
        homeServiceProviders(
          searchType: $searchType
          searchValue: $searchValue
          serviceType: $serviceType
          city: $city
          state: $state
          isActive: $isActive
          pagination: $pagination
        ) {
          count
          rows {
            id
            firstName
            lastName
            phoneNumber
            email
            city
            state
            zip
            providerNotes
            source
            isActive
            backgroundCheck
            businessName
            backgroundCheckedAt
            backgroundCheckSourced
            paymentOptions
            professionalProfileUrl
            createdAt
            updatedAt
            rates {
              id
              providerId
              serviceType
              description
              hourlyRate
              currency
              isActive
              createdAt
              updatedAt
            }
          }
        }
      }
    `),
  });

  return response.data.homeServiceProviders;
};
